<template>
  <table
    class="table table-striped mb-0 mt-3"
    v-if="selectedData?.postpones?.length"
  >
    <thead class="thead-light">
      <th class="text-nowrap">Postponed Date</th>
      <th class="text-nowrap">Postponed (RH)</th>
      <th class="text-nowrap">Postponed Notes</th>
      <th class="text-nowrap">Attachments</th>
    </thead>
    <tbody>
      <tr v-for="(postpone, index) in selectedData.postpones" :key="index">
        <td class="font-semibold text-black text-nowrap">
          {{ formatDate(postpone.extra_date) }}
        </td>
        <td class="font-semibold text-black">
          {{ formatHours(postpone.extra_hours) }} Hours
        </td>
        <td class="font-semibold text-black">
          <template v-if="(postpone.reason || '').length > 24">
            <span>
              {{
                expandedNotes[index]
                  ? postpone.reason
                  : postpone.reason.slice(0, 34) + '...'
              }}
            </span>
            <a
              href="javascript:void(0)"
              class="text-primary ml-1"
              @click.prevent="toggleNotes(index)"
            >
              {{ expandedNotes[index] ? 'less' : 'more' }}
            </a>
          </template>
          <template v-else>
            {{ postpone.reason || '-' }}
          </template>
        </td>
        <td class="font-semibold text-black">
          <b-badge
            v-for="(file, idx) in postpone?.maintenance_attachments"
            :key="`att-${idx}`"
            variant="warning"
            pill
            class="mr-2 cursor-pointer"
            @click="onPreview(file?.fileurl)"
          >
            {{ file?.filename }}
            <i class="fa fa-download ml-2" style="font-size: 12px"></i>
          </b-badge>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { previewFile } from '@/src/plugins/helpers'

export default {
  name: 'TablePostponed',
  props: {
    selectedData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      expandedNotes: {},
    }
  },
  methods: {
    toggleNotes(index) {
      this.$set(this.expandedNotes, index, !this.expandedNotes[index])
    },
    onPreview(fileUrl) {
      previewFile(fileUrl)
    },
    formatDate(date) {
      if (!date) return '-'
      const options = { year: 'numeric', month: 'long', day: 'numeric' }
      return new Date(date).toLocaleDateString(undefined, options)
    },
    formatHours(hours) {
      return hours?.toLocaleString() || '0'
    },
  },
}
</script>
